import type { CanvasShape } from "@cohesive/api-entities";

import { Circle } from "./Circle";
import { Cylinder } from "./Cylinder";
import { Diamond } from "./Diamond";
import { Pentagon } from "./Pentagon";
import { Rectangle } from "./Rectangle";
import { Triangle } from "./Triangle";

export const ShapeComponents = {
  rectangle: Rectangle,
  circle: Circle,
  diamond: Diamond,
  triangle: Triangle,
  pentagon: Pentagon,
  cylinder: Cylinder,
} as const;

export type ShapeType = CanvasShape["shape_type"];

export interface ShapeProps {
  width: number;
  height: number;
  fill?: string;
  fillOpacity?: number;
  stroke?: string;
  strokeWidth?: number;
  strokeDasharray?: string;
  strokeLinejoin?: "round" | "miter" | "bevel";
  strokeLinecap?: "round" | "butt" | "square";
}

export const SHAPE_LABELS: Record<ShapeType, string> = {
  rectangle: "Rectangle",
  circle: "Circle",
  diamond: "Diamond",
  triangle: "Triangle",
  pentagon: "Pentagon",
  cylinder: "Cylinder",
};

export const ALL_SHAPE_TYPES: ShapeType[] = [
  "rectangle",
  "circle",
  "diamond",
  "triangle",
  "pentagon",
  "cylinder",
];
